import 'arrive';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

// Ensure ScrollTrigger stabilizes after images/fonts load
window.addEventListener('load', () => {
    // double refresh helps when fonts swap
    setTimeout(() => ScrollTrigger.refresh(), 50);
    setTimeout(() => ScrollTrigger.refresh(), 350);
});

document.arrive('.block-accordions-animated', { existing: true }, function (el) {
    // Cache section wrapper and content to pin
    const sectionWrapper = el.querySelector('.section-wrapper');
    if (!sectionWrapper) return;

    // Scope all selectors to this specific block instance
    const accordions = el.querySelectorAll('.accordion-item');

    // Bootstrap collapse state class toggle
    accordions.forEach(item => {
        const collapse = item.querySelector('.accordion-collapse');
        if (!collapse) return;
        collapse.addEventListener('show.bs.collapse', () => {
            item.classList.add('is-open');
            ScrollTrigger.refresh(); // height change on open
        });
        collapse.addEventListener('hide.bs.collapse', () => {
            item.classList.remove('is-open');
            ScrollTrigger.refresh(); // height change on close
        });
    });

    // Elements to reveal
    const revealItems = el.querySelectorAll(
        '.block-accordions-animated__label, .block-accordions-animated__wrapper .accordion-item'
    );

    // Skip if nothing to animate
    if (!revealItems.length) return;

    // Default hidden state
    gsap.set(revealItems, { autoAlpha: 0, y: 24 });

    // Build timeline
    const tl = gsap.timeline({ defaults: { ease: 'power2.out' }, paused: true });

    tl.to(revealItems, {
        autoAlpha: 1,
        y: 0,
        duration: 0.5,
        stagger: 0.1,
        clearProps: 'transform,opacity',
        immediateRender: false
    });

    // Responsive pinning: disable on very small screens if needed
    const shouldPin = () => window.matchMedia('(min-width: 768px)').matches;

    // Create a ScrollTrigger that pins the wrapper shortly and plays the reveal ONCE
    const st = ScrollTrigger.create({
        trigger: sectionWrapper,
        start: 'top top+=12',
        // very short pin span so the section returns to normal flow right after reveal
        end: '+=1',
        pin: sectionWrapper,
        pinSpacing: true,
        scrub: false,
        // don't bind the animation directly so it never replays
        invalidateOnRefresh: true,
        once: true,
        onEnter: () => {
            // play the reveal only once
            if (!tl.isActive() && tl.progress() === 0) {
                tl.play(0).eventCallback('onComplete', () => {
                    // freeze timeline at end and remove callbacks; keep flow intact
                    tl.pause(1);
                    tl.eventCallback('onComplete', null);
                });
            }
        },
        onLeave: () => {
            // when leaving forward, ensure timeline is finalized
            if (tl.progress() < 1) {
                tl.progress(1).pause(1);
            }
        },
        onLeaveBack: () => {
            // prevent replay when scrolling back up
            tl.pause(1);
        },
        onRefreshInit: () => {
            // toggle pin per breakpoint
            st && st.vars && (st.vars.pin = shouldPin() ? sectionWrapper : false);
        }
    });

    // Recalculate when images inside the section load
    const images = sectionWrapper.querySelectorAll('img');
    images.forEach(img => {
        if (img.complete) return;
        img.addEventListener('load', () => ScrollTrigger.refresh(), { once: true });
        img.addEventListener('error', () => ScrollTrigger.refresh(), { once: true });
    });
});